import React, { type ReactNode } from "react";

interface Props {
  title: string;
  wide?: boolean;
  children: ReactNode;
  actions?: ReactNode;
}

export default function ChartCard({ title, wide, children, actions }: Props) {
  return (
    <div className={`bg-[#1e2130] border border-[#2a2d3e] rounded-xl p-5 overflow-hidden ${wide ? "col-span-full" : ""}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-base font-semibold text-gray-200">{title}</h3>
        {actions}
      </div>
      {children}
    </div>
  );
}
